const siteMetaData = {
  title: `Preem`,
  siteUrl: process.env.GATSBY_SITE_URL ?? `https://texaco.preem.se`,
  defaultLocale: "de",
};

export default siteMetaData;
